import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Card className="project-card-view">
        <div 
          className="project-img-wrapper" 
          onClick={handleShow} 
          style={{ cursor: "pointer", overflow: "hidden", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }}
        >
          <Card.Img variant="top" src={props.imgPath} alt="card-img" className="project-img" />
        </div>
        <Card.Body className="d-flex flex-column">
          <Card.Title onClick={handleShow} style={{ cursor: "pointer", fontWeight: "bold", fontSize: "1.2rem" }}>
            {props.title}
          </Card.Title>
          <Card.Text style={{ textAlign: "justify", flexGrow: 1, fontSize: "0.95rem", color: "rgba(255, 255, 255, 0.85)" }}>
            {props.shortDescription || props.description}
          </Card.Text>

          <Button variant="primary" onClick={handleShow} className="mt-auto w-100 mb-2 view-details-btn">
            View Details ✨
          </Button>
        </Card.Body>
      </Card>

      <Modal 
        show={show} 
        onHide={handleClose} 
        size="lg" 
        centered 
        className="project-modal"
        scrollable={true}
      >
        <Modal.Header closeButton closeVariant="white" className="border-0 pb-0">
          <Modal.Title style={{ color: "#fff", fontWeight: "bold" }}>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2 custom-modal-body">
          <div className="text-center">
            <img 
              src={props.imgPath} 
              alt="project-demo" 
              className="img-fluid rounded mb-4 shadow-lg modal-hero-img" 
            />
          </div>
          <div className="modal-description" style={{ color: "#e2e2e2", fontSize: "0.95rem", lineHeight: "1.6" }}>
            {props.description}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-center pt-0 pb-4">
          {props.ghLink && (
            <Button variant="outline-light" href={props.ghLink} target="_blank" className="mx-2 modal-btn">
              <BsGithub /> &nbsp;
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>
          )}

          {!props.isBlog && props.demoLink && (
            <Button variant="primary" href={props.demoLink} target="_blank" className="mx-2 modal-btn">
              <CgWebsite /> &nbsp; Visit Site
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
